import { render } from "./units.vue?vue&type=template&id=782740b2&scoped=true&ts=true"
import script from "./units.vue?vue&type=script&lang=ts"
export * from "./units.vue?vue&type=script&lang=ts"

import "./units.vue?vue&type=style&index=0&id=782740b2&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782740b2"]])

export default __exports__